'use client';

import dynamic from 'next/dynamic';

import type { RecommendationsClientProps } from './recommendations-client';

const RecommendationsClientLazy = dynamic(
  () =>
    import('./recommendations-client').then((m) => ({
      default: m.RecommendationsClient,
    })),
  { ssr: false }
);

export const RecommendationsClientDynamic = (
  props: RecommendationsClientProps
) => <RecommendationsClientLazy {...props} />;
